// ImageShowcase.js
import { useState, useEffect } from "react";
import Navbar from "../navbar";
import Hotel from "../images/Hotel.jpg";
import Resort from "../images/Resort.jpg";
import Restro from "../images/Restro.jpg";
import Cafe from "../images/Cafe.jpg";
import Banquet from "../images/Banquet.jpg";
import { useNavigate } from "react-router-dom";

const content = [
  {
    image: Resort,
    title: "Resort Essentials",
    // stats: "10K+",
    // statsText: "Hotels Trust Us",
    // description: "Creating Seamless Guest Experiences",
    rightTitle: "Creating Seamless Guest Experiences",
    rightDescription: "We help resorts deliver unforgettable stays through reliable, high-quality essentials that reflect their unique identity. From arrival to departure, every detail is supported by our trusted network to ensure comfort, consistency, and effortless hospitality."
  },
  {
    image: Hotel,
    title: "Hotel Supplies",
    // stats: "50%",
    // statsText: "Reduced Environmental Impact",
    // description: "Reliable Solutions for Every Hotel Need",
    rightTitle: "Reliable Solutions for Every Hotel Need",
    rightDescription: "We help hotels simplify their procurement process with dependable, high-quality supplies tailored to their brand standards. From daily operations to guest experience essentials, we ensure consistency, reliability, and on-time delivery—making procurement effortless for every property."
  },
  {
    image: Restro,
    title: "Restaurant Solutions",
    // stats: "1000+",
    // statsText: "Custom Designs Created",
    // description: "Enhancing Every Dining Moment",
    rightTitle: "Enhancing Every Dining Moment",
    rightDescription: "We support restaurants with dependable and customizable solutions designed to complement their service style. Every product is selected to maintain consistency, elevate presentation, and help you focus on what matters most—delivering exceptional dining experiences."
  },
  {
    image: Cafe,
    title: "Everyday Cafe Essentials",
    // stats: "75+",
    // statsText: "Countries Served",
    // description: "Serving Comfort in Every Cup",
    rightTitle: "Serving Comfort in Every Cup",
    rightDescription: "We provide cafés with thoughtfully selected products that blend functionality and design. From the counter to the customer table, our reliable range helps you create a cozy, consistent, and memorable atmosphere that keeps guests coming back."
  },
  {
    image: Banquet,
    title: "Event & Banquet Needs",
    // stats: "75+",
    // statsText: "Countries Served",
    // description: "Designed for Grand Occasions",
    rightTitle: "Designed for Grand Occasions",
    rightDescription: "We support banquets with reliable, ready-to-use essentials that bring elegance and efficiency to every event. From setup to service, our solutions ensure a polished experience that helps you deliver memorable gatherings with ease and confidence."
  },
];

const SCROLL_POINTS = [
    0,      // Image 1 is active from 0px
    1000,   // Image 2 is active from 1000px
    2000,   // Image 3 is active from 2000px
    3000,   // Image 4 is active from 3000px
    4000,   // Image 5 is active from 3000px
];
console.log(SCROLL_POINTS.length)

const getCurrentImageIndex = (scrollY) => {
    let index = 0;
    // Loop through the scroll points in reverse to find the latest point passed
    for (let i = SCROLL_POINTS.length - 1; i >= 0; i--) {
        if (scrollY >= SCROLL_POINTS[i]) {
            index = i;
            break;
        }
    }
    return index;
};


export default function ScrollImages() {
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate();

  // --- Scroll Logic ---
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const newIndex = getCurrentImageIndex(scrollY);

      if (newIndex !== current) {
        setCurrent(newIndex);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [current]);

  const currentContent = content[current];

  return (
    <div className="relative">
      <div className="flex">
        <Navbar/>
      </div>
      {/* Sticky container for content */}
      <div 
        className="flex flex-col lg:flex-row items-center justify-center bg-gray-50 px-4 sm:px-8 py-8 sticky top-0 z-10 min-h-screen"
      >
        {/* Left section */}
        <div className="w-full lg:w-1/4 text-center lg:text-left mb-8 lg:mb-0 flex flex-col items-center lg:items-start">
          <h1 className="text-2xl sm:text-4xl lg:text-5xl font-serif mb-4 lg:mb-8 transition-all duration-700">
            {currentContent.title}
          </h1>
          <div className="transition-all duration-700">
            {currentContent.stats && <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold mb-2">{currentContent.stats}</h2>}
            {currentContent.statsText && <p className="text-gray-700">{currentContent.statsText}</p>}
            {currentContent.description && <p className="text-gray-600 mt-4">{currentContent.description}</p>}
          </div>
        </div>

        {/* Image section */}
        <div className="w-full lg:w-2/4 flex justify-center items-center mb-8 lg:mb-0">
          <img
            key={current}
            src={currentContent.image}
            alt={currentContent.title}
            className="w-full max-w-xs sm:max-w-md lg:max-w-xl h-auto max-h-[300px] sm:max-h-[400px] lg:max-h-[500px] object-contain transition-opacity duration-700 ease-in-out rounded-2xl shadow-lg" 
            style={{ opacity: 1 }}
          />
        </div>

        {/* Right section */}
        <div className="w-full lg:w-1/4 text-center lg:text-left flex flex-col items-center lg:items-start mt-4 lg:mt-0">
          <h2 className="text-lg sm:text-xl lg:text-2xl font-serif mb-2 lg:mb-4 transition-all duration-700">
            {currentContent.rightTitle}
          </h2>
          <p className="text-gray-600 mb-4 lg:mb-6 transition-all duration-700 text-base sm:text-lg lg:text-xl">
            {currentContent.rightDescription}
          </p>
          <button onClick={() => navigate('/all-categories')} className="bg-black text-white px-6 py-2 rounded-full hover:bg-gray-800 transition-colors text-sm sm:text-base lg:text-lg">
            DISCOVER MORE
          </button>
        </div>
      </div>

      {/* Scroll sections - these create the actual scroll space */}
      {content.map((_, index) => (
        <div 
          key={index} 
          className="h-screen bg-transparent"
          aria-hidden="true"
        />
      ))}
    </div>
  );
}